import React,  { Component } from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import {withStyles} from '@material-ui/core/styles';
import {BoxDrag} from './BoxDrag'
import {Dustbin} from './Dustbin'

require('highcharts/modules/funnel')(Highcharts);

const useStyles = (theme) => ({
  root: {
    display: 'flex',
    marginBottom: '1rem',
    marginTop: '1rem',
  },
  panel:{
    maxHeight: 380,
    overflow: 'auto',    
  }
})

class ChartTypeFunnel extends Component {
  constructor(props){
    super(props)
    this.state = {
      isLoaded:false,
      funnelDescription:'',
      funnelValue:'',
      options: {
        chart: {
            type: 'funnel'
        },
        title: {
            text: ' '
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b> ({point.y:,.0f})',
                    softConnector: true
                },
                center: ['40%', '50%'],
                neckWidth: '30%',
                neckHeight: '25%',
                width: '80%'
            }
        },
        legend: {
            enabled: false
        },
        series: [{
            name: ' ',
            data: [
                ['Website visits', 15654],
                ['Downloads', 4064],
                ['Requested price list', 1987],
                ['Invoice sent', 976],
                ['Finalized', 846]
            ]
        }],            
      },
      managerOptions: [
        {
          allowedDropEffect: "any",
          title: "Categorias", 
          identify: "category",   
          data:[],    
        },
        {
          allowedDropEffect: "any",
          title: "Séries", 
          identify: "series",       
          data:[],        
        }
        
    
      ], 
    }
  }

  componentDidUpdate(prevProps, prevState){    
    if(!prevState.isLoaded){
      this.loadingAll()      
    }    
  }

  loadingAll = () => {      
   
    if(!this.props.report) return    
    let newOption = {}

    
    // Object.assign(newOption, this.state.options)      
    Object.assign(newOption, this.props.report)      

    if(!newOption.series)
      newOption.series = []

    newOption.series.map(serie => serie.data = this.props.dataset.map(o=>o[serie.name]))   

    // let managerOption = {}
    // if(this.props.managerOptions && this.props.managerOptions.length > 10){
    //   managerOption = JSON.parse(this.props.managerOptions)
    // } else {
    //   managerOption = this.state.managerOptions
    // }
    
    // if(typeof managerOption === "string"){
    //   managerOption = JSON.parse(managerOption);
    // }

    this.setState({
      isLoaded: true,
      managerOptions: this.props.managerOptions,
      options: newOption,       
    })    
  }

  getPropertiesName = (data) => {          
    return this.props.dataset && this.props.dataset.length > 0
      ?Object.getOwnPropertyNames(this.props.dataset[0]).sort():[]         
  }

  handleSelected = (item, dropResult) => {        
    let newMp = [...this.state.managerOptions]
    const indexMp = newMp.map(m=>m.identify).indexOf(dropResult.name);
    //se já existe no array, não irá adicionar
    if(newMp[indexMp].data.find((d)=>d.name === item.name)){
      return
    }
    newMp[indexMp].data.push({
      name: item.name,
      color: '',
    }) 
    this.setState({managerOptions: newMp})
    this.managerOption(item.name, dropResult.name)
  }

  eventOnDelete = (name, item,  identify) => {         
    // this.props.eventOnDelete
    let newMp = [...this.state.managerOptions]
    const indexMp = newMp.map(m=>m.identify).indexOf(identify)
    const newData = newMp[indexMp].data.filter(i => i.name !== name)
    newMp[indexMp].data = newData
    this.setState({managerOptions: newMp})
    this.managerOption(name, identify)
  }
  
  eventOnColor = (e, b, item, identify) => {     
    // this.props.eventOnColor    
    let newMp = [...this.state.managerOptions]
    const indexMp = newMp.map(m=>m.identify).indexOf(identify)
    const indexData = newMp[indexMp].data.map(d=>d.name).indexOf(item.name)
    newMp[indexMp].data[indexData] = {
      name: item.name,
      color: e.hex,
    }
    this.setState({managerOptions: newMp})
    this.managerOption(item.name, identify)
  }

  managerOption = (name, identify) => {

    let newOpition =  {}

    Object.assign(newOpition, this.state.options)
  

    // this.state.managerOptions    
    // const mpOption = this.state.managerOptions[this.state.managerOptions.map(m=>m.identify).indexOf(identify)]
        
    if(!newOpition.series[0].data || newOpition.series[0].data === undefined){
      newOpition.series[0].data = []
    }
    
    

    if(identify === "category"){    
      this.setState({funnelDescription: name})      
    }

    if(identify === "series"){          
      this.setState({funnelValue: name})                
    }

    if(this.state.funnelDescription && this.state.funnelValue){
      newOpition.series[0].data = this.props.dataset.map(d => {
        return [d[this.state.funnelDescription], d[this.state.funnelValue]]}
      )
    }
    
    this.setState({options: newOpition})      
    this.props.onEventOption(newOpition)  
    this.props.onEnvetManagerOptions(this.state.managerOptions)  
  }

  render(){

    const { classes} = this.props;

    return(
      <div>
        <div className={classes.root}>

          <div className={classes.panel} >                   
                {this.getPropertiesName().map((item) =>               
                  <BoxDrag key={item} name={item} eventOnChange={this.handleSelected} />
                )}          
              </div>      

              {this.state.managerOptions.map((item, index)=> 
                <div key={index} >             
                  <Dustbin   
                      key={index}                
                      allowedDropEffect={item.allowedDropEffect} 
                      title={item.title} 
                      identify={item.identify}                  
                      data={item.data}     
                      eventOnDelete={this.eventOnDelete}             
                      eventOnColor={this.eventOnColor}             
                    />
                </div>)}
                                  
          </div>  
      
          <HighchartsReact          
            highcharts={Highcharts}          
            options={this.state.options}
          />
        
      </div>
    )
  }

}

export default withStyles(useStyles)(ChartTypeFunnel)